/**
 * "Transcribe all" planning (OutlierOS lib/transcription-batch.ts, adapted): which reels to transcribe now,
 * highest outlier first, packed greedily into the credits left (a reel that doesn't fit is skipped, but shorter
 * reels further down can still fit). Reels with a transcript are free to open; reels without a saved video
 * can't be transcribed until the creator is rescanned.
 */
import { creditsForSeconds } from './credits';

export interface PlanReel { pk: string; outlierScore: number | null; durationS: number | null; hasTranscript: boolean; hasVideo: boolean }

export interface TranscribePlan {
  run: Array<{ pk: string; credits: number }>;
  alreadyDone: number;
  noVideo: number;
  skippedForCredits: number;
  estimatedCredits: number;
}

export function planTranscribeAll(reels: PlanReel[], opts: { available: number | null; secondsPerCredit: number }): TranscribePlan {
  const alreadyDone = reels.filter((r) => r.hasTranscript).length;
  const noVideo = reels.filter((r) => !r.hasTranscript && !r.hasVideo).length;
  const eligible = reels.filter((r) => !r.hasTranscript && r.hasVideo)
    .sort((a, b) => (b.outlierScore ?? -1) - (a.outlierScore ?? -1));
  let budget = opts.available ?? Infinity;
  const run: TranscribePlan['run'] = [];
  let skipped = 0;
  for (const r of eligible) {
    const credits = creditsForSeconds(r.durationS ?? 60, opts.secondsPerCredit);
    if (credits <= budget) {
      run.push({ pk: r.pk, credits });
      budget -= credits;
    } else skipped++;
  }
  return { run, alreadyDone, noVideo, skippedForCredits: skipped, estimatedCredits: run.reduce((n, r) => n + r.credits, 0) };
}
